import React from "react";
import * as h from '../helpers/helpers';
import { GroupImagesForExhibits } from "../helpers/imageHelpers";

// TAB TAB-C
export function TITLE({title}) {
	return (
		<div className='text-[62px] w-full h-[64px] mt-[52px] mb-3 flex items-center'>
			{title}
		</div>
	)
}

export function TITLE_ADD({title}) {
	return (
		<div className='mpbx text-[24px] w-full mb-[36px]'>
			{title}
		</div>
	)
}

export function SUM_HD() {
	return (
		<div className='mb-4'>
			<div className='mpbx pl-2 w-full text-[28px] h-[36px] flex items-center'>
				SUMMARY
			</div>
			<div className='hr-2' />
		</div>
	)
}

export function SIG_B({name, date}) {

	return (
		<div className='mbr w-[528px] mt-6 flex flex-col'>
			<div className="w-full text-end pr-6">{date}</div>
			<div className="flex flex-row  border-t-[1px] border-gray-500">
				<div className="w-[300px]">{name}</div>
				<div className="w-full text-end pr-2">Date of Signature and Report</div>
			</div>
		</div>
	)
}

export function TAB({title, gray, continued, tx}) {
	//console.log("continued: ", continued);
	var bg = gray ?  'bg-gray-200 text-black' :  'bg-black text-white';
	var cn = 'mpb flex flex-row rounded-t-2xl px-4 min-w-[288px] w-fit h-[31px] ' + bg;
	return (
		<div className="mt-[39px]">
			<div className="flex flex-row">
				<div className={cn}>
					<div className='flex items-center'>
						{title}
					</div>
					{ continued &&
						<div className='mprx text-[14px] flex items-center pl-2'>
							(Continued)
						</div>
					}
				</div>
				{ tx &&
					<div className='mpr italic flex items-center pl-2'>
						{tx}
					</div>
				}
			</div>
			<div className='hr-half' />
		</div>
	)
}

export function TAB_PROJECT({title}) {
	//console.log("continued: ", continued);
	var cn = 'mpb flex flex-row items-center pl-2 ';
	return (
		<div className="mt-[39px]">
			<div className="flex flex-row">
				<div className='mpb flex flex-row rounded-t-2xl px-4 min-w-[288px] w-fit h-[31px] items-center bg-black text-white'>
					{title}
				</div>
				<div className={cn} >
					<div className="" >Planned Unit Development (PUD)</div>
					<Checkbox checked={global.ptr.bPUD} />
					<div className="pl-10" >Condominium</div>
					<Checkbox checked={global.ptr.bCondominium} />
					<div className="pl-10" >Cooperative</div>
					<Checkbox checked={global.ptr.bCooperative} />
					<div className="pl-10" >Condop</div>
					<Checkbox checked={global.ptr.bCondop} />
				</div>
			</div>
			<div className='hr-half' />
		</div>
	)
}

export function TX_B({title}) {
	return (
		<div className='mpb w-[528px] px-2 flex flex-row mpb'>
				{title}
		</div>
	)
}

export function TX_BI({title}) {
	return (
		<div className='mpb italic w-[528px] px-2 flex flex-row mpb'>
				{title}
		</div>
	)
}

export function TXR({title, value}) {
		return (
			<div className='w-[528px]'>
				<div className="flex flex-row">
					<div className='mpr min-w-[300px] '>
						<div className="pl-2 pr-2">{title}</div>
					</div>
					<div className='mpr '>
						<div>{value}</div>
					</div>
				</div>
				<div className="hr-half-50-22" />
			</div>
		)
}

export function TXR_I({title, value, space}) {
	//console.log("TXR_I: ", title, typeof value, value);
	if (!value) return "";
	try {
		var sp = space ? "mt-4" : "";
		return (
			<div className={sp}>
				{ typeof value === "object" &&
					value.map((v, i) => {
						if (i > 0) title = "";
						return (<TXR_I_X key={i} title={title} value={value[i]} />)
					})
				}
				{ typeof value !== "object" &&
					<TXR_I_X title={title} value={value} />		
				}
			</div>
		)
	 } catch (err) {
		console.log("TXR_I", err);
		console.log(title, value);
	 }
}

function TXR_I_X({title, value}) {
		return (
			<div className='w-[528px]'>
				<div className="flex flex-row whitespace-pre-wrap">
					<div className='mpr min-w-[300px] '>
						<div className="pl-6 pr-2">{title}</div>
					</div>
					<div className='mpr flex items-end align-text-bottom'>
						<div>{value}</div>
					</div>
				</div>
				<div className="hr-half-50-22" />
			</div>
		)
}

export function TXR_II({title, value}) {
	//console.log("TXR_II: ", title, typeof value, value);
	if (!value) return;
	return (
		<div>
			{ typeof value === "object" &&
				value.map((v, i) => {
					if (i > 0) title = "";
					return (<TXR_II_X key={i} title={title} value={value[i]} />)
				})
			}
			{ typeof value !== "object" &&
				<TXR_II_X title={title} value={value} />		
			}
		</div>
	)
}

function TXR_II_X({title, value}) {
		return (
			<div className='w-[528px]'>
				<div className="flex flex-row">
					<div className='mpr min-w-[300px] '>
						<div className="pl-16 pr-2">{title}</div>
					</div>
					<div className='mpr '>
						<div>{value}</div>
					</div>
				</div>
				<div className="hr-half-50-22" />
			</div>
		)
}

export function TXR_B({title, value, space}) {
	if (!value || value === "") return undefined;
	try {
		if (value === true) value = "";
		//console.log("TXR_B: ", title, value);
		return (
			<div className={space ? "mt-3" : ""}>
				{ typeof value === "object" &&
					value.map((v, i) => {
						if (i > 0) title = "";
						return (<TXR_B_X key={i} title={title} value={value[i]} />)
					})
				}
				{ typeof value !== "object" &&
					<TXR_B_X title={title} value={value} />		
				}
			</div>
		)
	 } catch (err) {
		console.log("TXR_B", err);
		console.log(title, value);
	 }
}

function TXR_B_X({title, value}) {
		return (
			<div className='w-[528px]'>
				<div className="flex flex-row">
					<div className='mpb min-w-[300px] '>
						<div className="pl-2 pr-2 whitespace-pre-wrap">{title}</div>
					</div>
					<div className='mpr flex flex-col justify-end '>
						<div>{value}</div>
					</div>
				</div>
				<div className="hr-half-50-22" />
			</div>
		)
}

export function TXR_B_AMT({title, value}) {
		return (
			<div className='w-[528px]'>
				<div className="flex flex-row">
					<div className='mpb min-w-[300px] '>
						<div className="pl-2 pr-2 whitespace-pre-wrap">{title}</div>
					</div>
					<div className='mpr w-full text-right pr-6'>
						<div>{value}</div>
					</div>
				</div>
				<div className="hr-half-50-22" />
			</div>
		)
}

export function TXC_B({title, value}) {
	if (value === "") return undefined;
	return (
		<div className='w-[1080px] px-2 mt-[11px] flex flex-row'>
			<div ><span className="mpb pr-2">{title}</span>
			{value}</div>
		</div>
	)
}

export function TXC_B1({title, value}) {
	if (!value) return undefined;
	return (
		<div className='w-[528px] px-2 mt-[11px] flex flex-row'>
			<div ><span className="mpb pr-2">{title}</span>
			{value}</div>
		</div>
	)
}

export function TXC_I({comment}) {
	if (h.isEmpty(comment)) return undefined;
	return (
		<div className='w-[1080px] px-2 mt-[11px] mpr italic flex flex-row'>
			<div >{comment}</div>
		</div>
	)
}

export function TXC_I1({comment, nospace}) {
	var mt =  nospace ? "" : " mt-[11px]"
	//console.log("nospace: ", nospace, mt);
	return (
		<div className={'w-[528px] px-2 mpr italic flex flex-row'+ mt}>
			<div >{comment}</div>
		</div>
	)
}

export function TXC({comment}) {
	return (
		<div className='mpr w-[1080px] px-3 mt-[11px]'>
			{comment}
		</div>
	)
}

export function H1({title}) {
	return (
		<div className='w-[1080px] h-[30px] pl-2 mt-[30px] mpbx text-[18px] bg-gray-200'>
			{title}
		</div>
	)
}

export function H1_TX({title, value}) {
	return (
		<div className='mpr w-[1080px] h-[30px] flex flex-row pl-2 mt-[30px] bg-gray-200'>
			<div className="mpbx text-[18px]">{title}</div>
			<div className="mpr italic flex pl-6 items-center text-right">{value}</div>
		</div>
	)
}

export function H1_AMT({title, amount}) {
	return (
		<div className='mpb w-[1080px] h-[30px] flex flex-row pl-2 mt-[30px] bg-gray-200'>
			<div className="w-1/2 mprx text-[18px]">{title}</div>
			<div className="w-1/2 flex justify-end pr-6 items-center">{amount}</div>
		</div>
	)
}

export function H2({title}) {
	return (
		<div>
			<div className='w-[1080px] h-[30px] pl-2 mt-4 mpbx text-[18px]'>
				{title}
			</div>
			<div className='hr-2' />
		</div>
	)
}

export function H2_1({title}) {
	return (
		<div className='w-[528px] h-[30px] pl-2 mt-[30px] mpbx text-[18px]'>
			<div>
				{title}
			</div>
			<div className='hr-2-1' />
		</div>
	)
}

export function CK({title, value, bottom, yn}) {
	if (value === null || value === undefined) return undefined;
	var cn = 'w-[1080px]'
	if (bottom) cn += " mb-4";
	return (
		<>
			{ yn &&
			<YN />
			}
			<div className={cn}>
				<div className="flex flex-row">
					<div className='mpb w-[1002px] '>
						<div className="pl-2">{title}</div>
					</div>
					<div className='mpb w-[78x] '>
						<Checkboxes value={value} />
					</div>
				</div>
			</div>
		</>
	)
}

export function CK_H2({title, value}) {
	return (
		<div className="pl-2 mt-[8px] mpb mb-2">
			<div className="flex flex-row">
				<div className="ml-[465px] pr-3.5">Yes</div><div className="pr-2">No</div>
			</div>
			<div className="flex flex-row">
				<div className='mpb w-[450px] '>
					<div className="pl-2">{title}</div>
				</div>
				<div className='mpb w-[78x] '>
					<Checkboxes value={value} />
				</div>
			</div>
			<div className='hr-2' />
		</div>
	)
}

export function CK1({title, value, bottom, yn, nobold}) {
	if (h.isEmpty(value)) return;
	var cn = 'w-[528px]'
	if (bottom) cn += " mb-4";
	var bold =  nobold ? " mpr" : " mpb";
	return (
		<>
			{ yn &&
			<YN1 />
			}
			<div className={cn}>
				<div className="flex flex-row">
					<div className={'w-[450px]' + bold}>
						<div className="pl-2">{title}</div>
					</div>
					<div className={'w-[78x] ' + bold}>
						<Checkboxes value={value} />
					</div>
				</div>
			</div>
		</>
	)
}

export function CK1_I({title, value, bottom, yn, nobold}) {
	if (value === null || value === undefined) return undefined;
	var cn = 'w-[528px]'
	if (bottom) cn += " mb-4";
	var bold =  nobold ? " mpr" : " mpb";
	return (
		<>
			{ yn &&
			<YN1 />
			}
			<div className={cn}>
				<div className="flex flex-row">
					<div className={'w-[450px] '+ bold}>
						<div className="pl-6 pr-2">{title}</div>
					</div>
					<div className={'w-[78x] ' + bold}>
						<Checkboxes value={value} />
					</div>
				</div>
			</div>
			</>
	)
}

export function YN({title, value}) {
	return (
		<div className='w-[1080px]'>
			<div className="w-full h-[18px] flex flex-row justify-end items-baseline text-right" >
				<div className="pr-3.5">Yes</div><div className="pr-2">No</div>
			</div>
		</div>
	)
}

export function YN1({title, value}) {
	return (
		<div className='w-[528px]'>
			<div className="w-full h-[18px] flex flex-row justify-end items-baseline text-right" >
				<div className="pr-3.5">Yes</div><div className="pr-2">No</div>
			</div>
		</div>
	)
}

export function Checkboxes({value}) {
	var yn = value;
	if (typeof yn === 'string')
		yn = (yn === "Y" || yn === "Yes") ? true : false;
	//console.log("chk: ", yn);
	return (
		<div className="flex flex-row">
			<Checkbox checked={yn} />
			<Checkbox checked={!yn} />
		</div>
	)
}

export function Checkbox({checked}) {

	return (
		<div className="w-5 h-5 border-black border-[1px] mt-1 ml-4 pl-1 pb-2 mprx text-[15px]">
			{checked && <>X</>}
		</div>
	)
}


export function TB_SUB_H1({header}) {
	return (
		<div className='w-[1080px] h-[30px] pl-2 mpb text-white mprx text-[18px] bg-gray-400'>
			{header}
		</div>
	)
}

export function TB_SUB_H1_R({title,offset,width,value}) {
	var w = `${width}px`
	var o  = `${offset}px`
	return (
		<div className='w-[1080px] text-white mpb'>
			<div style={{width: `${w}`, marginLeft: `${o}` }} className="flex flex-row bg-gray-400">
				<div className="ml-4 w-1/2">{title}</div><div className="text-center w-1/2 mr-4">{value}</div>
			</div>
		</div>
	)
}

export function TB_SCA_SUB_H1({title, width, notop}) {
	let nt = notop ? "" : " mt-6";
	width = width ? width : 1080;
	let w = `${width}px`;
	return (
		<div style={{width: `${w}`}} className={'text-white bg-gray-600 mpb' + nt}>
			<div className="pl-4">{title}</div>
		</div>
	)
}

export function TB_SCA_H2({width, title}) {
	width = width ? width : 1080;
	let w = `${width}px`;
	return (
		<div style={{width: `${w}`}} className='text-black bg-gray-200 mpb'>
			<div className="pl-4">{title}</div>
		</div>
	)
}

export function COMMENTARY({title, value}) {
	if (!value || h.isEmpty(value)) return undefined;
	return (
		<>
			<H1 title={title} />
			<TXC comment={value} />
		</>
	)
}

export function TABLE({h1, titles, widths, values}) {
	if (!values || values.length === 0) return undefined;
	var wl = widths.length;
	var tl = titles.length;
	if (tl < wl) {
		//widths = widths.splice(tl+1);
	}
	//console.log("TABLE: ", titles, values);
	return (
		<>
			{ h1 &&
			<H1 title={h1} />
			}
			<TCH titles={titles} widths={widths} />
			<TB_LIST values={values} widths={widths} />
		</>
	)
}

export function TCH({titles, widths, centered}) {
	//console.log(titles);
	if (!titles) return undefined;

	return (
		<div className='mt-[11px] flex flex-row mpb'>
			{
				titles.map((title, i) => {
					var w = `${widths[i]}px`;
					var cn = centered ? " text-center" : "";
					return (
						<div key={i} style={{width: `${w}`}} className={'border-b-[1px] border-gray-400 flex flex-col justify-end pl-1 wspr ' + cn}>{title}</div>
					)
				}
			)}
		</div>
	)
}

export function TB_LIST({values, widths}) {
	//console.log("TB_LIST: ", values, widths, notop);
  if (!values) return undefined;
	if (typeof values !== "object") return undefined;
	return (
		<div>
			{
				values.map((vx, vi) => {
					//console.log("tbl: ", vi, vx);
					return (
						<TBML key={h.rKey()} values={vx} widths={widths} />
					)
				})
			}
		</div>
	)
}

export function TBML({values, widths}) {
	//console.log("TBML: ", values, widths, top);
	try {
	return (
		<div key={h.rKey()} className='w-full flex flex-row mpr '>
		{
			values.map((v, i) => {
				//var w = `width: ${widths[i]}px`;
				var w = {width: `${widths[i]}px`};
				var br = (i < widths.length - 1) ? " border-r-[1px] " : "";

				if (typeof v === 'string') {
					let bf = "";
					// v2 should b a string
					if (v.charAt(0) === "^") {
						v = v.substring(1);
						bf += " text-center";
					} else if (v.charAt(0) === ">") {
						v = v.substring(1);
						bf += " text-right pr-4";
					} else {
						bf += " px-2";
					}
					br += bf;
				}

				//console.log("l1: ", i, typeof v, v);
				//<div key={h.rKey()} className={' flex flex-col px-2 whitespace-pre-wrap border-gray-400 border-b-[1px]'} style={{width: `${w}`}} >

				return (
					<React.Fragment key={h.rKey()}>
					{ typeof v === 'string' && i < widths.length &&
							<div style={w} className={br +' flex flex-col wspr border-gray-400 border-b-[1px]'}>
							{v}
						</div>
					}
					{ typeof v === 'object' &&
						<div className="flex flex-col">
						{ // v should be an array of strings
							v.map((v1, i1) => {
								//console.log("l2: ", i1, typeof v1, v1);
								return (
									<div key={h.rKey()} style={{flexGrow: 1}} className={"flex flex-row"}>
									{
										v1.map((v2, i2) => {
											var br = (i2 < v1.length - 1) ? "tbml-r" : "tbml";
											var w = `${widths[i + i1]}px`;
											return (
												<div key={h.rKey()} className={"wspr " + br} style={{width: `${w}`}} >
													{v2}
												</div>
											)
										})
									}
									</div>
								)
							})
						}
						</div>
					}
					</React.Fragment>
				)
			})
		}
		</div>
	)
	} catch(err) {
		console.log("Trap TBML: ", err);
		console.log(values);
	}
}








export function IMAGE({category, caption}) {
	//if (!category) return;
	var image = global.ptr.subProp.GetImageByCategory(category);
	if (!image) return undefined
	//console.log("IMG: ", category, image);
	return (
		<div className={`flex flex-col image-border mt-7 `}>
			<div className={`image-inner bg-green-200`}>
				<div className="pl-4 pt-4">
					{image.imageCategoryType}
					<br />
					{image.imageCaptionCommentDescription}
				</div>
			</div>
		</div>
	)
}

export function IMAGE_TEMP({category, caption}) {
	//if (!category) return;
	var image = global.ptr.subProp.GetImageByCategory(category);
	if (!image) return undefined
	//console.log("IMG: ", category, image);
	return (
		<div className={`flex flex-col image-border-1 mt-7 `}>
			<div className={`image-inner-1 bg-green-200`}>
				<div className="pl-4 pt-4">
					{image.imageCategoryType}
					<br />
					{image.imageCaptionCommentDescription}
				</div>
			</div>
		</div>
	)
}
// <img className="image-inner-1" src={iimg} alt="" />

export function IMAGE_1({category}) {
	var image = global.ptr.subProp.GetImageByCategory(category);
	if (!image) return undefined
	var id = image.imageData;
	//console.log("IMAGE_1: ", typeof iimg, iimg);

	return (
		<div className="flex flex-col " >
			{ id &&
				<img className="image-inner-1" src={id} alt="" />
			}
			{ !id &&
			<span className="mpb">This file is missing: {image.imageFileLocationIdentifier}</span>
			}
		</div>
	)
}

export function IMAGE_MAP({category, image}) {
	if (category && !image) 
		image = global.ptr.subProp.GetImageByCategory(category);

	if (!image) return;

	let type = image.imageCategoryType;
	let title = h.toEnumText(type);
	title = h.addWithSpacer(title, image.imageCaptionCommentDescription, " - ");

	return (
		<div className={`flex flex-col image-map-border `}>
			<div className="pl-4 pt-4 pb-1 mpb">
				{title}
			</div>

			<div className="flex flex-col " >
				<img className="image-map" src={image.imageData} alt="" />
			</div>
		</div>
	)
}

export function IMAGE_SC({image}) {
	//if (!category) return;
	if (!image) return undefined
	//console.log("IMG: ", category, image);
	return (
		<div className='flex flex-col'>
			<img className="image-sc" src={image.imageData} alt="" />
		</div>
	)
}

export function IMAGE_RI({image}) {
	//if (!category) return;
	if (!image) return;
	//console.log("IMG: ", category, image);
	return (
		<div className='flex flex-col'>
			<img className="image-ri" src={image.imageData} alt="" />
		</div>
	)
}

export function IMAGE_RAW({image}) {
	if (!image) return;
	var id = image.imageData;
	return (
		<div className="flex flex-col " >
			<img className="image-inner-1" src={id} alt=""/>
		</div>
	)
}

export function IMAGE_CAT({image, notop, noleft}) {
	if (!image) return;
	let id = image.imageData;
	let type = image.imageCategoryType;
	var title = "";
	if (image.imageSourceCaption) 
		title = image.imageSourceCaption;
	else {
		if (!type.endsWith("Exhibit"))
			title = h.toEnumText(type);
		title = h.addWithSpacer(title, image.imageCaptionCommentDescription, " - ");
	}

	let cn = notop ? (noleft ? "image-cat-border-nt-nl" : "image-cat-border-nt") : (noleft ? "image-cat-border-nl" : "image-cat-border");
	return (
		<div className={"flex flex-col " + cn}>
			<div className="pl-4 pt-2 h-[60px] mpb whitespace-pre-wrap">
				{title}
			</div>
			<div className="flex flex-col " >
				{ id &&
					<img src={id} className="image-cat" alt=""/>
				}
				{ !id &&
					<span className="pl-4 pt-4 mpb">This file is missing: {image.imageFileLocationIdentifier}</span>
				}
			</div>
		</div>
	)
}

export function EXHIBITS({title, id, values}) {
	let images = [];
	if (id) {
		id.forEach(cat => {
			let imgs = global.ptr.subProp.GetImagesByCategory(cat);
			if (imgs.length > 0) images.push(...imgs);
		})
		if (images.length < 1) return;
	} else if (values && values.length > 0) {
		images = values;
	} else
		return;

	let imgList = GroupImagesForExhibits(images);
	
	return (
		<>
		<H1 title={title} />
		<div className="mt-4" >
			{
				imgList.map((img, ii) => {
					let notop = (ii > 0) ? true : false;
					let len = img.length;
					if (len === 1) {
						return (
							<div key={ii} >
								<IMAGE_MAP image={img[0]} notop={notop} noleft={false} />
							</div>
						)
					} else {
						return (
						<div key={ii} className='col2-ng'>
							<div>
								<IMAGE_CAT image={img[0]} notop={notop} noleft={false} />
							</div>
							<div>
								<IMAGE_CAT image={img[1]} notop={notop} noleft={true} />
							</div>
						</div>
						)
					}
				})
			}
		</div>
		</>
	)
}


